import { noop } from 'lodash'
import React from 'react'

import { ListGroupItem } from '../ListGroup'
import Removable from '../Removable'

type TFieldComponentWrapper = {
  onRemove?: (index: number) => void
  children?: React.ReactNode
  index: number
  padRight?: boolean
  withPadding?: boolean
}

const FieldComponentWrapper = (
  props: TFieldComponentWrapper,
): React.ReactElement => {
  const { onRemove, index, children, padRight, withPadding = true } = props

  const remove = (): void => {
    if (onRemove) {
      onRemove(index)
    }
  }

  return (
    <ListGroupItem noMargin>
      <Removable
        onRemove={onRemove ? remove : undefined}
        withPadding={withPadding}
        padRight={padRight}
      >
        {children}
      </Removable>
    </ListGroupItem>
  )
}

export default FieldComponentWrapper
